import { render, staticRenderFns } from "./SkeletonLoaderBuilder.vue?vue&type=template&id=c05200ee"
import script from "./SkeletonLoaderBuilder.vue?vue&type=script&lang=js"
export * from "./SkeletonLoaderBuilder.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoaderBuilder.vue?vue&type=style&index=0&id=c05200ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports